import { useState } from "react";
import { Users, Loader2, Check, ChevronDown, ChevronRight } from "lucide-react";

/** Conseil collegial : plusieurs experts se prononcent, ODYS'GUIDE arbitre. */
export const CollegialPanel = ({ collegial, index = 0 }) => {
  const [openIdx, setOpenIdx] = useState(null);
  if (!collegial) return null;

  const experts = collegial.experts || [];
  const interventions = collegial.interventions || [];
  const running = collegial.phase && collegial.phase !== "done";

  return (
    <div
      className="mb-3 rounded-lg overflow-hidden"
      data-testid={`collegial-panel-${index}`}
      style={{ border: "1px solid #CFE0DE", background: "#F2F8F7" }}
    >
      <div className="flex items-center gap-2.5 px-3 py-2.5">
        <span
          className="w-7 h-7 rounded-md flex items-center justify-center shrink-0"
          style={{ background: "#1F6F6B" }}
        >
          {running ? (
            <Loader2 className="w-3.5 h-3.5 text-white animate-spin" />
          ) : (
            <Users className="w-3.5 h-3.5 text-white" />
          )}
        </span>
        <div className="flex-1 min-w-0">
          <span
            className="block text-[0.58rem] uppercase font-semibold"
            style={{ color: "#1F6F6B", letterSpacing: "0.2em" }}
          >
            Conseil collegial
          </span>
          <span
            className="block text-sm font-semibold"
            style={{ color: "#16233B", fontFamily: "var(--serif, Fraunces)" }}
          >
            {running
              ? `${experts.length || "Plusieurs"} experts se prononcent avant l'arbitrage`
              : `Arbitrage rendu apres l'avis de ${interventions.length} experts`}
          </span>
        </div>
      </div>

      <div className="px-3 pb-3 space-y-1.5">
        {experts.map((e, i) => {
          const done = !!interventions[i]?.content;
          const active = collegial.activeIndex === i && running;
          const open = openIdx === i;
          return (
            <div
              key={e.id || i}
              data-testid={`collegial-expert-${index}-${i}`}
              className="rounded-md overflow-hidden"
              style={{ background: "#fff", border: "1px solid #DCE9E7" }}
            >
              <button
                onClick={() => done && setOpenIdx(open ? null : i)}
                className="w-full flex items-center gap-2 px-2.5 py-2 text-left"
              >
                {done ? (
                  <Check className="w-3.5 h-3.5 shrink-0" style={{ color: "#1F6F6B" }} />
                ) : active ? (
                  <Loader2 className="w-3.5 h-3.5 shrink-0 animate-spin" style={{ color: "#1F6F6B" }} />
                ) : (
                  <span className="w-3.5 h-3.5 shrink-0 rounded-full" style={{ border: "1.5px solid #CFE0DE" }} />
                )}
                <span className="text-xs font-semibold flex-1 truncate" style={{ color: "#16233B" }}>
                  {e.name}
                </span>
                {active && (
                  <span className="text-[0.65rem]" style={{ color: "#5E7371" }}>
                    prend la parole...
                  </span>
                )}
                {done && (open
                  ? <ChevronDown className="w-3.5 h-3.5" style={{ color: "#1F6F6B" }} />
                  : <ChevronRight className="w-3.5 h-3.5" style={{ color: "#1F6F6B" }} />)}
              </button>
              {open && done && (
                <div
                  className="px-3 pb-3 pt-1 text-xs whitespace-pre-wrap leading-relaxed"
                  style={{ color: "#3C4A63", maxHeight: "260px", overflowY: "auto" }}
                  data-testid={`collegial-intervention-${index}-${i}`}
                >
                  {interventions[i].content}
                </div>
              )}
            </div>
          );
        })}
        {running && collegial.phase === "verdict" && (
          <div className="pt-1.5 px-1">
            <div className="h-1 rounded-full overflow-hidden relative" style={{ background: "#DCE9E7" }}>
              <div
                className="h-full absolute inset-y-0 w-1/3 animate-[deepSweep_1.8s_ease-in-out_infinite]"
                style={{ background: "linear-gradient(90deg, transparent, #1F6F6B, transparent)" }}
              />
            </div>
            <p className="text-[0.7rem] pt-1.5" style={{ color: "#5E7371" }}>
              ODYS'GUIDE confronte les avis et redige son arbitrage (30 a 60 s)
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
